import { Injectable, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { NavigationDataService } from '../navigation-data/navigation-data.service';
import { Subject } from 'rxjs';

/**
 * A placeholder for a service that generates the left hand menu from navigation data.
 */
@Injectable({
  providedIn: 'root'
})
export class SidebarMenuService {
  public menuToggle$ = new Subject();
  public activeRoute$ = new Subject();
  public menuItems = [];

  PAGES_WITH_MENU_CLOSED_ON_LOAD = ['Kanban']

  constructor(
    private navigationDataService: NavigationDataService,
    private router: Router,
  ) {
  }

  public init(): void {
    (window as any).NG_SHARED_SIDEBAR_MENU_SERVICE = this;

    // build menuTree as soon as navigation data is ready
    this.navigationDataService.navigationLoaded
    // once nav data is loaded, build the menuTree for use in the template
    .subscribe(data => this.buildMenuTree(data));
  }

  private buildMenuTree(data: any): any[] {
    // start building our complete menuTree for the sidebar-menu
    this.menuItems = this.navigationDataService.applications;

    return this.menuItems;
  }
}
